import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.placeTypes.length
    ? _c(
        "div",
        {
          staticClass: "d-flex flex-column ga-3",
          attrs: { "data-qa": "lpu_doctors_list_price" },
        },
        [
          _setup.placeTypes.length > 1
            ? _c(
                "div",
                { staticClass: "d-flex flex-wrap ga-2" },
                _vm._l(_setup.placeTypes, function (placeType) {
                  return _c(
                    VChip,
                    {
                      key: placeType,
                      staticClass: "text-none branding-btn",
                      class:
                        placeType === _vm.value
                          ? "branding-btn--primary"
                          : "branding-btn--background",
                      attrs: { value: placeType },
                      on: {
                        click: function ($event) {
                          return _setup.emit("input", placeType)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _setup.tStatic(_setup.PLACE_TYPE_LABEL[placeType])
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.isFreeWithTreatment
            ? _c("div", [
                _c("div", { staticClass: "d-flex align-center ga-3 mb-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-h6 text-success--text d-flex align-center ga-1",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.tStatic("Бесплатно")) +
                          "\n        "
                      ),
                      _c(VImg, {
                        staticClass: "flex-shrink-0",
                        attrs: {
                          width: "20",
                          height: "20",
                          contain: "",
                          src: "/static/_v1/pd/icons/ui-kit/promotion/tag-discount.svg",
                          alt: _setup.tStatic("Иконка Акции"),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _setup.clinicPrice
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-body-2 text-secondary--text text-decoration-line-through",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.formatClinicPrice) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-caption text--text" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.tStatic(
                          "Консультация бесплатна при условии дальнейшего лечения. Подробности уточняйте в клинике."
                        )
                      ) +
                      "\n    "
                  ),
                ]),
              ])
            : _setup.isClubPrice
            ? _c("div", { staticClass: "d-flex ga-6" }, [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center ga-1 text-subtitle-1 font-weight-medium error--text",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.formatClubPrice) +
                          "\n        "
                      ),
                      _c(VImg, {
                        staticClass: "flex-shrink-0",
                        attrs: {
                          width: "24",
                          height: "24",
                          contain: "",
                          src: "/static/_v1/pd/icons/ui-kit/club/club-percent.svg",
                          alt: _setup.tStatic("Иконка Процент Клуба"),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-caption error--text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.tStatic("Клубная цена")) +
                        "\n      "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-subtitle-1 text-secondary--text text-decoration-line-through",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.formatClinicPrice) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "text-caption text-secondary--text d-flex align-center pa-0",
                      attrs: {
                        type: "button",
                        "data-qa": "lpu_doctors_list_club_info",
                      },
                      on: {
                        click: function ($event) {
                          _setup.isClubInfoOpen = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.tStatic("Подробнее о цене")) +
                          "\n        "
                      ),
                      _c("span", {
                        staticClass: "ui-icon-arrow-right ui-icon-fz-smaller",
                      }),
                    ]
                  ),
                ]),
              ])
            : _setup.activePrice != null
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "text--text",
                    class:
                      _vm.value === "clinic" && _setup.activePrice === 0
                        ? "text-h6"
                        : "text-subtitle-1 font-weight-medium mb-1",
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_setup.activePriceLabel) + "\n    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.value === "clinic" && _setup.activePrice
                  ? _c(
                      "div",
                      { staticClass: "text-caption text-secondary--text" },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_setup.tStatic("Оплата в клинике")) +
                            "\n    "
                        ),
                      ]
                    )
                  : _vm.value === "telemed"
                  ? _c(
                      "div",
                      { staticClass: "text-caption text-secondary--text" },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_setup.tStatic("Оплата при записи")) +
                            "\n    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _setup.isClubPrice && _setup.clubOfferData
            ? _c(_setup.ClubPriceInfo, {
                attrs: {
                  "full-price": _setup.clinicPrice || 0,
                  "club-offer-data": _setup.clubOfferData,
                  "skip-window-open": true,
                },
                model: {
                  value: _setup.isClubInfoOpen,
                  callback: function ($$v) {
                    _setup.isClubInfoOpen = $$v
                  },
                  expression: "isClubInfoOpen",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }